const Types = {
  SUBSCRIPTIONS__GET_SUBSCRIPTIONS: 'SUBSCRIPTIONS__GET_SUBSCRIPTIONS',
  SUBSCRIPTIONS__MANAGE_SUBSCRIPTIONS: 'SUBSCRIPTIONS__MANAGE_SUBSCRIPTIONS',
};
export default Types;
